import styled from "styled-components";
import { theme } from "./theme";
import bgImage from "assets/Davey-Pool-Pro-BG-Image.webp";

export const AuthContainer = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);

  @media (max-width: ${theme.breakpoints.tablet}) {
    flex-direction: column;
  }
`;

export const AuthSidebar = styled.div`
  background: linear-gradient(145deg, ${theme.colors.secondary} 0%, #1a1a1a 100%);
  width: 30%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem 2rem;
  color: ${theme.colors.white};
  position: relative;
  overflow: hidden;
  order: 1;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(45deg, rgba(255, 210, 0, 0.05) 0%, transparent 100%);
    z-index: 1;
  }

  & > * {
    position: relative;
    z-index: 2;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    width: 100%;
    min-height: auto;
    padding: 2rem 1.5rem;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  opacity: 0.95;
`;

export const LogoSeparator = styled.div`
  width: 2px;
  height: 45px;
  background: linear-gradient(to bottom, transparent, ${theme.colors.primary}, transparent);
  margin: 0 20px;
  border-radius: 1px;
`;

export const BrandLogo = styled.img`
  width: 160px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
`;

export const AnniversaryLogo = styled.img`
  width: 110px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
`;

export const AuthTitle = styled.h1`
  color: ${theme.colors.white};
  margin: 0 0 2.5rem;
  font-size: ${theme.fontSizes.xlarge};
  font-weight: ${theme.fontWeights.bold};
  text-align: center;
  letter-spacing: 0.5px;
`;

export const AuthContent = styled.div`
  flex: 1;
  background-image: url(${bgImage});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  position: relative;
  order: 2;

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: 1.5rem;
    min-height: 40vh;
    background-attachment: scroll;
  }
`;

export const PoolProLogo = styled.img`
  position: absolute;
  top: 30px;
  right: 30px;
  width: 200px;
  filter: brightness(1.2) drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  z-index: 2;

  @media (max-width: ${theme.breakpoints.tablet}) {
    width: 150px;
    top: 20px;
    right: 20px;
  }
`;

export const SidebarFormContainer = styled.div`
  width: 100%;
  max-width: 380px;
  margin-bottom: 3rem;
`;

export const SidebarFormTitle = styled.h2`
  margin: 0 0 1.25rem;
  color: ${theme.colors.white};
  font-size: ${theme.fontSizes.large};
  font-weight: ${theme.fontWeights.bold};
  text-align: center;
`;

export const AuthDescription = styled.p`
  color: rgba(255, 255, 255, 0.85);
  margin: 0 0 1.25rem;
  font-size: ${theme.fontSizes.small};
  line-height: 1.5;
  text-align: center;
`;

export const AuthMessageBlock = styled.div`
  text-align: center;
  color: ${theme.colors.white};
`;

export const AuthSuccessIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
  color: ${theme.colors.primary};
`;

export {
  FormGroup,
  Label,
  Input,
  PasswordField,
  PasswordInput,
  PasswordToggle,
  ErrorMessage,
  Button,
  AuthLink,
  LinkRow,
  ForgotLinkRow,
  LoadingSpinner,
  FormSection,
  DividerLine,
  
} from "./auth.form.styles";
